import { useUserStore } from "../store/userStore";

/**
 * El rol `cliente`: quien tiene una o dos unidades y entra a ver dónde están.
 *
 * ── Por qué un rol propio y no `monitor` ────────────────────────────────────
 * `monitor` vigila flotas ajenas y necesita lo contrario que éste: filtros,
 * búsqueda, contadores por estado, varias unidades a la vista. Colgarle a los
 * dos la misma pantalla obliga a elegir a quién se le empeora.
 *
 * ── Qué cambia, y qué NO ────────────────────────────────────────────────────
 * Cambia la MISMA sección de mapa, no una app aparte: el cliente entra a
 * `/map` igual que todos y recibe otro panel. Así no hay dos mapas que
 * mantener, ni dos sitios donde arreglar el mismo bug.
 *
 * Lo que no cambia son los permisos. Esto decide qué se DIBUJA; quién puede ver
 * qué lo sigue decidiendo el API. Un rol de interfaz que además concediera
 * acceso sería una puerta trasera: bastaría escribir el rol en el
 * `localStorage` para entrar a otra empresa.
 */
export const CLIENTE_ROLE_ID = "cliente";

/** El nombre, por si el documento trae uno y no el id. */
export const CLIENTE_ROLE_NAME = "cliente";

/**
 * ¿Este usuario es un cliente de uso rápido?
 *
 * Mira el id y el nombre del rol. El `localStorage` entra sólo como respaldo,
 * igual que en `RoleProtectedRoute`: al recargar, el store tarda un instante en
 * hidratarse y sin esto la pantalla parpadearía del panel completo al simple.
 */
export const esRolCliente = (
  roleId?: string | null,
  roleName?: string | null,
): boolean => {
  const id = (roleId ?? "").trim().toLowerCase();
  const nombre = (roleName ?? "").trim().toLowerCase();
  return id === CLIENTE_ROLE_ID || nombre === CLIENTE_ROLE_NAME;
};

export function useEsCliente(): boolean {
  const user = useUserStore((state) => state.user);

  const roleId = user?.role_id ?? localStorage.getItem("userRoleId");
  const roleName = user?.role_name ?? localStorage.getItem("userRole");

  return esRolCliente(roleId, roleName);
}
